var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var dataGreen = {
    green100: "#D9FFF1",
    green200: "#B3FAE1",
    green300: "#89EAC7",
    green400: "#68DCB2",
    green500: "#43CD9B",
    green600: "#38BE8F",
    green700: "#28A87F",
    green800: "#17926F",
    green900: "#007357",
};
var dataIndigo = {
    indigo100: "#DEEFFF",
    indigo200: "#BEE0FF",
    indigo300: "#9BCFFF",
    indigo400: "#6DB9FF",
    indigo500: "#2697FF",
    indigo600: "#1675FF",
    indigo700: "#1A54FF",
    indigo800: "#2A35F5",
    indigo900: "#3112F1",
};
var dataGold = {
    gold100: "#FFFDCF",
    gold200: "#FFF7AB",
    gold300: "#FFF389",
    gold400: "#FFEF5A",
    gold500: "#FFDE2E",
    gold600: "#F1C527",
    gold700: "#E3AC1F",
    gold800: "#D49216",
    gold900: "#BF6C0A",
};
var dataViolet = {
    violet100: "#F9E6FF",
    violet200: "#F3D5FF",
    violet300: "#EBBAFF",
    violet400: "#E1A3FF",
    violet500: "#D171FF",
    violet600: "#C547FF",
    violet700: "#AE13F5",
    violet800: "#9309D4",
    violet900: "#7900B2",
};
var dataOrange = {
    orange100: "#FFEEE5",
    orange200: "#FFDECF",
    orange300: "#FFBC9C",
    orange400: "#FF9A69",
    orange500: "#FF7836",
    orange600: "#F06B2A",
    orange700: "#E45E1D",
    orange800: "#C34E15",
    orange900: "#B53C01",
};
var dataTeal = {
    teal100: "#D9FAFF",
    teal200: "#AAF5FF",
    teal300: "#6DEEFF",
    teal400: "#31E6FF",
    teal500: "#00CCEA",
    teal600: "#00B8DE",
    teal700: "#00A4D2",
    teal800: "#008FC6",
    teal900: "#007ABC",
};
var dataRed = {
    red100: "#FFECED",
    red200: "#FFD0D6",
    red300: "#FFB9C4",
    red400: "#FF9DAF",
    red500: "#FF7893",
    red600: "#F65D84",
    red700: "#F14979",
    red800: "#E5346C",
    red900: "#BF1A54",
};
var dataLegacy = {
    purple60: "#8C56AA",
    blue60: "#569DE9",
    cyan20: "#D7F3EC",
    cyan60: "#37C4A0",
    gold60: "#DEBD58",
};
export var data = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, dataLegacy), dataGreen), dataIndigo), dataGold), dataViolet), dataOrange), dataTeal), dataRed), { data: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, dataLegacy), dataGreen), dataIndigo), dataGold), dataViolet), dataOrange), dataTeal), dataRed) });
